import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/platform")({
  component: PlatformRoute,
})

function PlatformRoute() {
  return <Outlet />
}
